$(document).ready(function () {

  (function initStickyCalc() {
    var OFFSET = 10;
    var CALC_PADDING_V = 80;
    var HEADER_CHANGE_MIN_WIDTH = 1279;

    function getHeaderBottom() {
      var selectors = [
        'sticky-header',
        '#shopify-section-header header',
        '#shopify-section-header',
        '.site-header',
        '.header-wrapper',
        'header[role="banner"]',
        'header'
      ]; 
      for (var i = 0; i < selectors.length; i++) {
        var el = document.querySelector(selectors[i]);
        if (!el) continue;
        var rect = el.getBoundingClientRect();
        if (rect.height > 0) return Math.max(0, rect.bottom);
      }
      return 0;
    }

    function update() {
      if ($(window).width() <= 1279) return;

      var winWidth = $(window).width();
      var headerBottom = winWidth > HEADER_CHANGE_MIN_WIDTH ? getHeaderBottom() : 0;
      var topOffset = headerBottom + OFFSET;

      $('.height-calculator').each(function () {
        var $section = $(this);
        var $calc = $section.find('.height-calculator__calc');
        var $content = $section.find('.height-calculator__calc-content');

        if (!$calc.length || $calc.css('position') !== 'sticky') return;

        if (!$calc.data('hc-transition-set')) {
          $calc.css('transition', 'top 0.25s cubic-bezier(0.25, 0.46, 0.45, 0.94)');
          $content.css('transition', 'max-height 0.25s cubic-bezier(0.25, 0.46, 0.45, 0.94)');
          $calc.data('hc-transition-set', true);
        }

        $calc.css('top', topOffset + 'px');

        var $body = $section.find('.height-calculator__body');
        var bodyRect = $body.length ? $body[0].getBoundingClientRect() : $section[0].getBoundingClientRect();

        var bodyVisibleTop = Math.max(bodyRect.top, topOffset);
        var bodyVisibleBot = Math.min(bodyRect.bottom, window.innerHeight);
        var bodyVisibleH   = Math.max(0, bodyVisibleBot - bodyVisibleTop);

        var maxH = bodyVisibleH - CALC_PADDING_V;

        if (maxH > 80) {
          $content.css('max-height', maxH + 'px');
        }
      });
    }

    var headerUpdateTimer;
    $(window).on('scroll', function () {
      requestAnimationFrame(update);
    });
    $(window).on('resize', function () {
      requestAnimationFrame(update);
      clearTimeout(headerUpdateTimer);
      headerUpdateTimer = setTimeout(update, 350);
    });
    update();
    $(window).on('load', update);
    setTimeout(update, 100);
    setTimeout(update, 500);
  })();

  var heightFeet   = null;
  var heightInches = 0;
  var lastCm       = null;

  function initDropdown(dropdownId, onSelect) {
    var $dropdown = $('#' + dropdownId);
    if (!$dropdown.length) return;

    var $toggle = $dropdown.find('.selected');
    var $label  = $toggle.find('span');

    $toggle.on('click', function (e) {
      e.stopPropagation();
      $('.dropdown').not($dropdown).removeClass('open');
      $dropdown.toggleClass('open');
    });

    $dropdown.find('.sort-option').on('click', function () {
      var value = $(this).data('value');
      var text  = $(this).text();

      $dropdown.find('.sort-option.sort-selected').removeClass('sort-selected');
      $(this).addClass('sort-selected');

      $label.text(text);
      $dropdown.addClass('touched');
      $dropdown.removeClass('open');

      onSelect(value);
    });

    $(document).on('click', function (e) {
      if (!$dropdown[0].contains(e.target)) {
        $dropdown.removeClass('open');
      }
    });
  }

  initDropdown('height-dropdown-feet', function (val) {
    heightFeet = parseInt(val);
    calculateFromFeet();
  });

  initDropdown('height-dropdown-inches', function (val) {
    heightInches = parseInt(val);
    calculateFromFeet();
  });

  function cmToFtIn(cm) {
    var totalInches = cm / 2.54;
    var ft  = Math.floor(totalInches / 12);
    var inc = Math.round(totalInches % 12);
    if (inc === 12) { ft++; inc = 0; }
    return ft + '\'&thinsp;' + inc + '"';
  }

  function fmtImperial(item) {
    return cmToFtIn(item.min) + ' &ndash; ' + cmToFtIn(item.max) + ' <span class="hc-result__unit">ft</span>';
  }

  function fmtCm(item) {
    return item.min + '&ndash;' + item.max + ' <span class="hc-result__unit">cm</span>';
  }

  var useImperial = false;

  function fmt(item) {
    return useImperial ? fmtImperial(item) : fmtCm(item);
  }

  function calcSeated(h) {
    return {
      desk:    {
        min: Math.max(58, Math.round(h * 0.3772)),
        max: Math.max(63, Math.round(h * 0.4072))
      },
      chair:   { min: Math.round(h * 0.2395), max: Math.round(h * 0.2695) },
      monitor: { min: Math.round(h * 0.6946), max: Math.round(h * 0.7246) },
    };
  }

  function calcStanding(h) {
    return {
      desk:    {
        min: Math.min(127, Math.round(h * 0.6347)),
        max: Math.min(133, Math.round(h * 0.6647))
      },
      monitor: { min: Math.round(h * 0.9401), max: Math.round(h * 0.9701) },
    };
  }

  function updateWrapper($wrap, data) {
    $wrap.find('.height-calculator__result-desk-height .hc-result__value').html(fmt(data.desk));

    if (data.chair) {
      $wrap.find('.height-calculator__result-chair-height .hc-result__value').html(fmt(data.chair));
      $wrap.find('.hc-badge--chair .hc-badge__value').html(fmt(data.chair));
    }

    $wrap.find('.height-calculator__result-monitor-height .hc-result__value').html(fmt(data.monitor));
    $wrap.find('.hc-badge--desk .hc-badge__value').html(fmt(data.desk));
    $wrap.find('.hc-badge--monitor .hc-badge__value').html(fmt(data.monitor));
  }

  function clearWrapper($wrap) {
    $wrap.find('.hc-result__value, .hc-badge__value').html('&mdash;');
  }

  function getProductsByHeight(h) {
    if (h >= 145 && h <= 169) {
      return ['HomePro'];
    } else if (h >= 170 && h <= 195) {
      return ['HomePro', 'HomeOne', 'HomeMax'];
    } else if (h >= 196 && h <= 200) {
      return ['HomePro', 'HomeOne'];
    } else if (h >= 201 && h <= 205) {
      return ['HomePro'];
    }
    return [];
  }

  function updateShopBtn(h) {
    var products = getProductsByHeight(h);
    var $btn = $('a.height-calculator__result-btn');

    if (!$btn.length) return;

    var baseHref = $btn.data('original-href');
    if (!baseHref) {
      baseHref = $btn.attr('href');
      $btn.data('original-href', baseHref);
    }

    if (!products.length) {
      $btn.attr('href', baseHref);
      return;
    }

    var params = products.map(function (p) {
      return 'title=' + encodeURIComponent(p);
    }).join('&');

    var separator = baseHref.indexOf('?') > -1 ? '&' : '?';
    $btn.attr('href', baseHref + separator + params);
  }

  var currentMode = 'seated';

  $('.height-calculator__mode').on('click', function () {
    $('.height-calculator__mode').removeClass('active');
    $(this).addClass('active');
    currentMode = $(this).data('mode');
    if (lastCm) {
      runCalculation(lastCm);
    }
  });

  $('.height-calculator__input').on('input', function () {
    useImperial = false;
    heightFeet   = null;
    heightInches = 0;
    $('#height-dropdown-feet .selected span').text('Height (feet)');
    $('#height-dropdown-inches .selected span').text('Height (inches)');
    $('#height-dropdown-feet .sort-option.sort-selected').removeClass('sort-selected');
    $('#height-dropdown-inches .sort-option.sort-selected').removeClass('sort-selected');
    calculate();
  });

  function calculateFromFeet() {
    if (heightFeet === null) return;
    useImperial = true;
    var totalInches = heightFeet * 12 + heightInches;
    var cm = Math.round(totalInches * 2.54);
    $('.height-calculator__input').val('');
    runCalculation(cm);
  }

  function calculate() {
    var raw = parseFloat($('.height-calculator__input').val());
    if (!raw) {
      showEmpty();
      return;
    }
    runCalculation(raw);
  }

  function runCalculation(cm) {
    var $input       = $('.height-calculator__input');
    var $error       = $('.height-calculator__input-error');
    var $output      = $('.height-calculator__output');
    var $placeholder = $output.find('.height-calculator__output-placeholder');
    var $sitting     = $output.find('.height-calculator__result.sitting');
    var $standing    = $output.find('.height-calculator__result.standing');

    if (!cm) {
      showEmpty();
      return;
    }

    lastCm = cm;

    var errorLow  = $input.data('error-low');
    var errorHigh = $input.data('error-high');

    if (cm < 145 || cm > 205) {
      $error.text(cm < 145 ? errorLow : errorHigh).show();
      $input.addClass('height-calculator__input--error');
      $output.removeClass('active');
      $placeholder.show();
      $sitting.hide();
      $standing.hide();
      clearWrapper($sitting);
      clearWrapper($standing);
      return;
    }

    $error.text('').hide();
    $input.removeClass('height-calculator__input--error');
    $output.addClass('active');
    $placeholder.hide();

    if (currentMode === 'seated') {
      $sitting.show();
      $standing.hide();
      updateWrapper($sitting, calcSeated(cm));
    } else {
      $standing.show();
      $sitting.hide();
      updateWrapper($standing, calcStanding(cm));
    }

    updateShopBtn(cm);
  }

  function showEmpty() {
    lastCm = null;
    var $output  = $('.height-calculator__output');
    var $sitting = $output.find('.height-calculator__result.sitting');
    var $standing = $output.find('.height-calculator__result.standing');
    $('.height-calculator__input-error').text('').hide();
    $('.height-calculator__input').removeClass('height-calculator__input--error');
    $output.removeClass('active');
    $output.find('.height-calculator__output-placeholder').show();
    $sitting.hide();
    $standing.hide();
    clearWrapper($sitting);
    clearWrapper($standing);
  }

});